// extracted by mini-css-extract-plugin
module.exports = {"body":"Landing_body__3sAYC","imgContainer":"Landing_imgContainer__1X3qx","textContainer":"Landing_textContainer__3mEO4","buttonWrapper":"Landing_buttonWrapper__2_SHK"};